import './navigation.js';

import bookmarkView from './views/BookmarkView.js';
import pledgeView from './views/PledgeView.js';
import statsView from './views/StatsView.js';
import successView from './views/SuccessView.js';
import tiersView from './views/TiersView.js';

import { state } from './model.js';

// *************************
//  Functions

const handleBookmarkClick = function () {
  // 1) Update state
  state.isBookmarked = !state.isBookmarked;

  // 2) Rerender bookmark button
  bookmarkView.render(state.isBookmarked);
};

const handleTierSelect = function (id) {
  // 1) Update selected tier in model
  state.setActiveTier(id);
};

const handlePledgeMade = function (amount) {
  // 1) Add submitted amount to funded money
  state.fundingStats.current += amount;

  // 2) Increase number of backers
  state.fundingStats.backers += 1;

  // 3) Decrease stock of active tier
  state.activeTier.stock -= 1;

  // 4) Rerender UI
  renderViews();

  // 5) Render success modal
  successView.render();
};

const handleClick = function (e) {
  // 1) Show pledge modal if user clicked on an element with .open-modal
  if (e.target.classList.contains('open-modal')) {
    pledgeView.render(state.getTiers());
  }
};

const renderViews = function () {
  bookmarkView.render(state.isBookmarked);
  statsView.render(state.fundingStats);
  tiersView.render(state.getTiers(false));
};

const init = function () {
  // 1) Register event handlers
  bookmarkView.registerHandler('click', handleBookmarkClick);
  pledgeView.registerHandler('select', handleTierSelect);
  pledgeView.registerHandler('submit', handlePledgeMade);

  // 2) Initial render
  renderViews();
};

// *************************
//  Event Listeners

document.body.addEventListener('click', handleClick);

init();
